import { render } from "./DebugDatastore.vue?vue&type=template&id=241257fb"
import script from "./DebugDatastore.vue?vue&type=script&lang=js"
export * from "./DebugDatastore.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__